<ng-container *ngIf="event">
  <ul [ngStyle]="locationStyle" class="context-menu-dropdown">
    <li *ngFor="let action of event.actions" class="context-menu-row">

      <div *ngIf="isVisible(action, event.value)" class="context-menu-row-item" [class.mod-spacer]="isSpacer(action)" (click)="execute(action, event.value)">
        <ng-container *ngIf="!isSpacer(action); else linkOrSpacer">
          <cp-icon [icon]="getIcon(action, event.value)" class="context-menu-icon">
          </cp-icon>
          <span class="context-menu-text">{{getName(action, event.value) | translate}}</span>
        </ng-container>
        <ng-template #linkOrSpacer>
          <a *ngIf="isLink(action); else spacer" class="context-menu-row-item" [href]="action.generateLink(event.value)">
            <cp-icon [icon]="getIcon(action, event.value)" class="context-menu-icon">
            </cp-icon>
            <span class="context-menu-text">{{getName(action, event.value) | translate}}</span>
          </a>
        </ng-template>
        <ng-template #spacer>
          <div class="context-menu-spacer"></div>
        </ng-template>
      </div>
    </li>
  </ul>
</ng-container>
